<template lang="pug">
  v-app
    map-menu
    v-toolbar(
      app
      color="green darken-3"
      dark
      :clipped-left="clipped"
    )
      v-toolbar-title(
        style="width: 300px"
        class="ml-0 pl-3"
        )
        v-toolbar-side-icon(@click.stop="toggleDrawer")
        span(
          class="hidden-sm-and-down"
        ) Growing Solutions
      v-text-field(
        flat
        solo-inverted
        prepend-icon="search"
        label="Search City"
        readonly
        class="hidden-sm-and-down"
        value="Bad Hersfeld"
      )
      v-spacer
      v-toolbar-items
        v-btn(flat)
          span(style="margin-right: 10px") Max Mustermann
          v-avatar(
            size="42"
          )
            img(src="@/assets/man.svg")
    v-content.nopadding
      Map
      v-snackbar(
        :timeout="toastTimeout"
        :bottom="true"
        :right="true"
        multi-line
        v-model="snackbar"
      )
        p {{ this.$store.state.toast }}
        v-btn(
          flat
          color="pink"
          @click.native="snackbar = false"
          ) Close
</template>

<script>
import { mapGetters } from 'vuex'
import Map from '@/components/map/Map'
import MapMenu from '@/components/map/MapMenu'

export default {
  name: 'App',
  data () {
    return {
      clipped: false
    }
  },
  components: {Map, MapMenu},
  computed: {
    ...mapGetters([
      'toastTimeout'
    ]),
    snackbar: {
      get () {
        return this.$store.state.toast
      },
      set (val) {
        this.$store.dispatch('SET_TOAST', val)
      }
    },
    setMapBounds: function (val) {
      console.log(val)
    }
  },
  methods: {
    toggleDrawer: function () {
      this.$store.dispatch('TOGGLE_DRAWER')
    }
  }
}</script>

<style>
.nopadding {
  padding: 0;
}
</style>
